//TODO: This needs to be moved to be specific of Beneficiary form validation

import { formatStringIfEducationSavings, isValidNumber } from 'services/BeneficiaryV2';

const ARIA_INVALID = 'aria-invalid';
export const handleError = (control, errorMessage) => {
  const beaconFormField = control.parentElement;
  let slottedError = beaconFormField.querySelector('[slot="error"]');
  if (!slottedError) {
    const errorContainer = document.createElement('div');
    errorContainer.slot = 'error';
    beaconFormField?.append(errorContainer);
    slottedError = errorContainer;
  }
  slottedError.innerText = errorMessage;
};

export const removeError = (control) => {
  const beaconFormField = control.parentElement;
  const slottedError = beaconFormField.querySelector('[slot="error"]');
  if (slottedError) {
    slottedError.remove();
  }
}

export const getErrorType = (validity) => {
  const { valueMissing, tooShort, tooLong, patternMismatch, rangeOverflow } = validity;
  if (valueMissing) return 'required';
  if (tooShort || tooLong || patternMismatch || rangeOverflow) return 'invalid';
  return null;
};

export const getErrorMessage = (controlId, errorType, errorMap, defaultMessage) => {
  for (const key in errorMap) {
    const regex = new RegExp(`^${key}`);
    if (regex.test(controlId)) {
      return errorMap[key][errorType] || defaultMessage;
    }
  }
  return defaultMessage;
};

export const validateAllocation = (control, errorMessages, invalidField, isDistributionError, errorType) => {
  //Do this before we parse the value to determine if the input value is actually a number before converting.
  const controlValueValid = isValidNumber(control.value.replace('%', ''));
  const value = parseFloat(control.value);
  const decimals = control.value.includes('.') && control.value.split('.')[1].replace('%', '');
  const isDecimalTooLong = decimals.length > 2;
  if(!controlValueValid) {
    const errorMessage = 'Invalid Allocation';
    handleError(control, errorMessage);
    control.setAttribute(ARIA_INVALID, 'true');
    if (!invalidField.some((field) => Object.values(field).includes(errorMessage))) {
      invalidField.push({[control.id]: errorMessage});
    }
  }
  if (isNaN(value) || value <= 0) {
    const errorMessage = errorMessages.ALLOCATION_VALUE_GREATER_ZERO;
    handleError(control, errorMessage);
    control.setAttribute(ARIA_INVALID, 'true');
    if (!invalidField.some((field) => Object.values(field).includes(errorMessage))) {
      invalidField.push({ [control.id]: errorMessage });
    }
  }
  if (isDistributionError) {
    const errorMessage = errorMessages[errorType];
    control.setAttribute(ARIA_INVALID, 'true');
    if (!invalidField.some((field) => Object.values(field).includes(errorMessage))) {
      invalidField.push({ [control.id]: errorMessage });
    }
  }
  if(isDecimalTooLong) {
    const errorMessage = 'Allocations cannot exceed two decimal points';
    handleError(control, errorMessage);
    control.setAttribute(ARIA_INVALID, 'true');
    if (!invalidField.some((field) => Object.values(field).includes(errorMessage))) {
      invalidField.push({ [control.id]: errorMessage });
    }
  }
  if (!(isNaN(value) || value <= 0) && !isDistributionError && !isDecimalTooLong && controlValueValid) {
    control.setAttribute(ARIA_INVALID, 'false');
  }
};

export const validateControl = (control, errorMessages, invalidField, isPrimaryDistributionError, isSecondaryDistributionError, isSpouseError, isEsa) => {
  const validity = control.validity;
  const errorType = getErrorType(validity);
  const errorMap = {
    'first-name': { required: errorMessages.FIRST_NAME_REQUIRED, invalid: errorMessages.INVALID_FIRST_NAME },
    'last-name': { required: errorMessages.LAST_NAME_REQUIRED, invalid: errorMessages.INVALID_LAST_NAME },
    'date-picker': { required: errorMessages.DATE_OF_BIRTHDAY, invalid: errorMessages.INVALID_DATE_OF_BIRTH },
    'taxId': { required: errorMessages.SOCIAL_SECURITY_NUMBER, invalid: errorMessages.INVALID_SOCIAL_SECURITY_NUMBER },
    'tin': { invalid: errorMessages.INVALID_TIN },
    'relationshipName': { required: errorMessages.RELATIONSHIP_NAME, invalid: formatStringIfEducationSavings(errorMessages.SPOUSE_RELATIONSHIP, isEsa)},
    'businessEntityName': { required: errorMessages.BUSINESS_ENTITY_NAME_REQUIRED, invalid: errorMessages.INVALID_BUSINESS_ENTITY_NAME },
    'Primary-allocation-': { required: errorMessages.ALLOCATION_VALUE_GREATER_ZERO, invalid: errorMessages.INVALID_ALLOCATION_PRIMARY },
    'Secondary-allocation-': { required: errorMessages.ALLOCATION_VALUE_GREATER_ZERO, invalid: errorMessages.INVALID_ALLOCATION_SECONDARY },
    'middle-name': { invalid: errorMessages.INVALID_MIDDLE_NAME },
  };

  if (errorType) {
    const errorMessage = getErrorMessage(control.id, errorType, errorMap, 'Please provide an answer.');
    handleError(control, errorMessage);
    invalidField.push({ [control.id]: errorMessage });
  } else if (/^Primary-allocation-/.test(control.id)) {
    validateAllocation(control, errorMessages, invalidField, isPrimaryDistributionError, isEsa ? 'INVALID_ALLOCATION_SUCCESSOR' : 'INVALID_ALLOCATION_PRIMARY');
  } else if (/^Secondary-allocation-/.test(control.id)) {
    validateAllocation(control, errorMessages, invalidField, isSecondaryDistributionError, 'INVALID_ALLOCATION_SECONDARY');
  } else if (control.id === "relationshipName" && isSpouseError) {
    const errorMessage = formatStringIfEducationSavings(errorMessages.SPOUSE_RELATIONSHIP, isEsa);
    handleError(control, errorMessage);
    control.setAttribute(ARIA_INVALID, 'true');
    if (!invalidField.some((field) => Object.values(field).includes(errorMessage))) {
      invalidField.push({ [control.id]: errorMessage });
    }
  }else if(control.id === "taxId" && control.value.length < 11 && control.value.length !== 0) {
    const errorMessage = errorMessages.INVALID_SOCIAL_SECURITY_NUMBER;
    handleError(control, errorMessage);
    control.setAttribute(ARIA_INVALID, 'true');
    if (!invalidField.some((field) => Object.values(field).includes(errorMessage))) {
      invalidField.push({ [control.id]: errorMessage });
    }
  }else if(control.id === "tin" && control.value.length < 10 && control.value.length !== 0) {
    const errorMessage = errorMessages.INVALID_TIN;
    handleError(control, errorMessage);
    control.setAttribute(ARIA_INVALID, 'true');
    if (!invalidField.some((field) => Object.values(field).includes(errorMessage))) {
      invalidField.push({ [control.id]: errorMessage });
    }}
};

export const processControl = (control, errorMessages, invalidField, isPrimaryDistributionError, isSecondaryDistributionError, isSpouseError, isEsa) => {
  if (!(control instanceof HTMLInputElement || control instanceof HTMLSelectElement)) {
    return;
  }

  try {
    control.checkValidity();
    validateControl(control, errorMessages, invalidField, isPrimaryDistributionError, isSecondaryDistributionError, isSpouseError, isEsa);
  } catch (error) {
    console.error(error, control);
  }
};

export const clearErrors = (form) => {
  const { elements } = form;
  Array.from(elements).forEach((control) => {
    if (control instanceof HTMLInputElement || control instanceof HTMLSelectElement) {
      removeError(control);
      control.setAttribute(ARIA_INVALID, 'false');
    }
  });
};

export const handleFormSubmit = (form, errorMessages, isPrimaryDistributionError, isSecondaryDistributionError, isSpouseError, isEsa, callback) => {
  if (!(form instanceof HTMLFormElement || form instanceof HTMLSelectElement)) {
    return [];
  }

  clearErrors(form);

  const { elements } = form;
  const invalidField = [];

  Array.from(elements).forEach((control) => {
    processControl(control, errorMessages, invalidField, isPrimaryDistributionError, isSecondaryDistributionError, isSpouseError, isEsa);
  });

  if (typeof callback === 'function') {
    callback(invalidField);
  }

  return invalidField;
};